import { render, staticRenderFns } from "./ProductionFlows.vue?vue&type=template&id=d70c9bfc&scoped=true&"
import script from "./ProductionFlows.vue?vue&type=script&lang=js&"
export * from "./ProductionFlows.vue?vue&type=script&lang=js&"
import style0 from "./ProductionFlows.vue?vue&type=style&index=0&id=d70c9bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70c9bfc",
  null
  
)

export default component.exports